<!-- 赞助方查询 -->
<template>
    <div >  
        <el-row class="mg-tb-20">
            <el-button type="primary" icon="el-icon-plus" @click="addDialog()">新增赞助方</el-button>
        </el-row>
        <el-table border :data="tableData" style="width: 100%;">
            <el-table-column  prop="sponsorName"  label="赞助方名称"  width="180"/>
            <el-table-column  prop="sponsorId"    label="赞助方账号"/>
            <el-table-column  prop="serialMark"  label="赛事标识"/>
            <el-table-column  fixed="right" label="操作"  width="120">
                <template slot-scope="scope" >
                    <el-button @click="updateDialog(scope.row)" type="text" size="medium">修改</el-button>
                    <el-button @click="deleteDialog(scope.row)" type="text" size="medium">删除</el-button>
                </template>                   
            </el-table-column>
        </el-table>
    <!-- 新增修改对话框 -->
    <el-dialog :title="titleSponsor" :visible.sync="open" width="600px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="150px">      
            <el-form-item label="赞助方名称" prop="sponsorName">
                <el-autocomplete style="width: 100%;" :clearable="true"
                    v-model="form.sponsorName"
                    :fetch-suggestions="querySearch"
                    placeholder=""
                    :trigger-on-focus="false"
                    @select="handleSelect"
                ></el-autocomplete>
                <!-- <el-input v-model="form.sponsorName"  placeholder="请输入赞助方名称" :clearable="true"
                    @input="getUserInfoSearch"/> -->
            </el-form-item>       
            <!-- <el-form-item label="赞助方账号" prop="sponsorId">
                <el-select v-model="form.sponsorId" style="width:100%">
                    <el-option 
                        v-for="item in userInfoOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                </el-select>
            </el-form-item>             -->
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>

export default {
    props: {
        publishId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            searchForm:{
                serialMark: '',
            },
            form: {
                index: '',
            },
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [],  
            amount: 0,  
            total: 0,
            titleSponsor: '',
            open: false,
            rules:{
                sponsorName: [
                    { required: true, message: "请输入赞助方名称", trigger: "blur" }
                ],
                sponsorId: [
                    { required: false, message: "请输入赞助方账号", trigger: "blur" }
                ],
            },
            userInfoOption:[]
        }   
    },
    created() {
        this.initData()
    },
    mounted() {

    },
    computed:{
        title(){
            return this.$route.meta.title
        }    
    },
    methods: {
        initData(){
            let params = {
                opcode:this.$code.SponsorQuery,
                i_serial_mark: this.publishId
            };
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){                 
                    if(res.Data.SumCount > 0){                        
                        let result = res.Data.DataTable;
                        this.tableData = result.map(item =>{
                            return{
                                index: item['序号'],
                                sponsorId: item['冠名方账号'],
                                serialMark: item['赛事标识'],
                                sponsorName: item['冠名方'],
                                des: item['系统内外'],
                            }
                        })
                        this.total = res.Data.SumCount
                    }else{
                        this.tableData = []
                    }
                }
            }).catch(error =>{
                console.log(error);
            })
        },
        addDialog(){
            this.form = {                
                sponsorName: '',
                sponsorId: '',
            }
            this.titleSponsor = '新增赞助方'
            this.open = true
            this.flag = 1
        },
        updateDialog(row){
            this.open = true
            this.titleSponsor = '修改赞助方'
            this.flag = 2
            this.form = {...row}
        },
        deleteDialog(row){
            this.flag = 3
            this.form = {...row}
            this.$confirm(`确认删除 ${row.sponsorName} 赞助方吗？`).then(res=>{
                this.submitForm()
            }).catch(err=>{
                console.log("取消")
            })
        },
        submitForm(){
            let params = {
                opcode:this.$code.SponsorAddOrUpdate,
                i_serial_mark: this.publishId,
                i_serial: this.form.index,
                v_title_name: this.form.sponsorName,
                v_title_no: this.form.sponsorId,
                i_flag: this.flag
            };
            this.$api.requestAPI(params).then( res =>{
                    if(res.IsSuccess){
                        this.$message.success(res.Message);  
                        this.initData()   
                        this.open = false        
                        this.userInfoOption = []
                        this.form.sponsorId = ''       
                    }else{
                        this.$message.error(res.Message);
                    }  
                }).catch( error =>{
                    console.log(error);
                })  
        },
        cancel(){
            this.open = false
            this.resetForm('form')
        },
        searchQuery() {
            this.initData()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        async querySearch(queryString, cb){
            let result = queryString ? await this.getUserInfoSearch(queryString) : []  
            cb(result)
        },
        // 模糊搜索查询
        getUserInfoSearch(val){
            return new Promise((resolve,reject)=>{
                if(val.length > 1){
                    let params = {
                        opcode: this.$code.UserInfoSearch,
                        v_name: val,
                        v_caption: '',
                        v_phone: '',
                    }
                    // 查询信息
                    this.$api._requestAPI(params).then(res => {
                        if (res.IsSuccess) {
                            let result = res.Data.DataTable
                            if(result.length === 0){
                                this.form.sponsorId = ''
                                this.userInfoOption = []
                            }else{
                                let arr  = result.map(item=>{
                                    return{
                                        value:item['姓名'] +''+ item['手机号'],
                                        sponsorId: item['会员账号'],
                                        username: item['姓名'],
                                        phone: item['手机号'],
                                        role: item['角色'],
                                        level: item['星级']
                                }
                            })                            
                            this.userInfoOption = arr.filter(i=>i.role === '掼蛋协会'||i.role === '掼蛋俱乐部')
                            resolve(this.userInfoOption)                         
                        }
                    }
                    }).catch(err => { reject(err)})
                }else{
                    this.form.sponsorId = ''
                }
            })         
        },
        handleSelect(row){
            this.form.sponsorName = row.username
            this.form.sponsorId = row.sponsorId
        },
        // 模糊搜索查询
        getUserInfoSearch2(val){
            if(val.length > 1){
                let params = {
                    opcode: this.$code.UserInfoSearch,
                    v_name: this.form.sponsorName,
                    v_caption: '',
                    v_phone: '',
                }
                // 查询账户信息
                this.$api._requestAPI(params).then(res => {
                    if (res.IsSuccess) {
                        let result = res.Data.DataTable
                        if(result.length === 0){
                            this.form.sponsorId = ''
                            // this.form.sponsorName = ''
                            this.userInfoOption = []
                        }else{
                            this.userInfoOption = result.map(item=>{
                                return{
                                    value:item['会员账号'],
                                    label: item['会员账号'],
                                    username: item['姓名'],
                                    phone: item['手机号'],
                                    role: item['角色'],
                                    level: item['星级']
                                }
                            })  
                            if(this.userInfoOption.length > 0){
                                this.form.sponsorId = this.userInfoOption[0].value 
                                // this.form.sponsorName = this.userInfoOption[0].username 
                            }else{
                                this.form.sponsorId = ''
                            }                            
                        }
                    }
                }).catch(err => {})
            }else{
                this.form.sponsorId = ''
            } 
        },
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
</style>


// WEBPACK FOOTER //
// src/views/publish/components/sponsor.vue